module.exports = __webpack_public_path__ + "packs/media/images/Herz-98ab3ee506dd45d3878b00ed7c63a926.svg";